import React from 'react';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { de, enUS } from 'date-fns/locale';

const fmtH = (h) => `${(h || 0).toFixed(1).replace('.', ',')} h`;

export const DayBreakdown = ({ days }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'de' ? de : enUS;
  const active = days.filter((d) => d.entries.length > 0);
  if (active.length === 0) {
    return <p className="text-sm text-zinc-400 py-4" data-testid="report-no-entries">{t('reports.noEntries')}</p>;
  }
  return (
    <ol className="space-y-3" data-testid="report-day-breakdown">
      {active.map((d) => (
        <li key={d.date} className="border-l-2 border-[#D93025]/30 pl-3" data-testid={`report-day-${d.date}`}>
          <div className="flex items-baseline justify-between gap-3">
            <span className="text-sm font-semibold text-zinc-900">{format(parseISO(d.date), 'EEEE, d. MMM', { locale })}</span>
            <span className="text-xs font-bold text-[#D93025] tabular-nums">{fmtH(d.hours)}</span>
          </div>
          <ul className="mt-1 space-y-0.5">
            {d.entries.map((e) => (
              <li key={e.id} className="flex gap-2 text-sm text-zinc-600">
                <span className="flex-1 min-w-0 [overflow-wrap:anywhere]">{e.description || <em className="text-zinc-400">{t('reports.noDescription')}</em>}</span>
                <span className="shrink-0 text-xs text-zinc-400 tabular-nums">{fmtH(e.hours)}</span>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ol>
  );
};

export { fmtH };
export default DayBreakdown;
